module.exports = __webpack_public_path__ + "img/fd73203.png";